<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-12">
          <h5>
            Retention Touchpoints
          </h5>
        </div>
      </div>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <ul v-else class="list-group">
      <li v-for="task in tasks" :key="task.id" class="list-group-item" style="padding: 10px 0">
        <div style="display: flex; flex-direction: row">
          <div class="text-muted"
               style="flex: 1; font-size: 24px; display: flex; justify-content: center; align-items: center;">
            <i class="fa fa-handshake"></i>
          </div>

          <div style="flex: 7 1 0%;">
            <div>
              <i>{{ task.attributes.portal_name }}</i>
            </div>

            <div class="text-muted" style="font-size: 12px; margin-top: 4px;">
              <template v-if="task.attributes.user_id">
                Assigned to: {{ task.attributes.user_name }}
              </template>
              <template v-else>
                Unassigned
              </template>
              &middot;
              Created: {{ formatDate(task.attributes.created_at) }}
            </div>
          </div>

          <div style="flex: 1; font-size: 24px; display: flex; justify-content: flex-end; align-items: center;">
            <button type="button" class="btn btn-lg" @click="createReminder(task)" style="background-color: transparent" title="Create Reminder">
              <i class="fa fa-calendar"></i>
            </button>

            <button type="button" class="btn btn-lg" @click="completeTask(task)" style="background-color: transparent" title="Mark as Completed">
              <i class="fa fa-check-circle"></i>
            </button>

            <button type="button" class="btn btn-lg" @click="openAssignModal(task)" style="background-color: transparent" title="Assign Task">
              <i class="fa fa-user"></i>
            </button>
          </div>
        </div>
      </li>

      <li v-if="tasks.length === 0" class="list-group-item text-center" style="padding: 50px;">
        <i class="fa fa-check-double text-muted" style="font-size: 96px;"></i>
        <br><br>
        <span class="text-muted">There are no retention touchpoint tasks for this company!</span>
      </li>
    </ul>

    <RetentionTouchpointReminderModal :task="creatingReminder" @created="loadTasks" />
    <RetentionTouchpointAssignModal :task="assigningTask" :users="users" @assigned="loadTasks" />
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import moment from 'moment'
import notify from '@/notify'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SaveHeight from '@/mixins/SaveHeight'
import RetentionTouchpointReminderModal
  from "../../../../../../Dashboards/MyFocus/Panels/RetentionTouchpointReminderModal.vue";
import RetentionTouchpointAssignModal
  from "../../../../../../Dashboards/MyFocus/Panels/RetentionTouchpointAssignModal.vue";

export default {
  components: {
    LoadingSpinner,
    RetentionTouchpointReminderModal,
    RetentionTouchpointAssignModal
  },

  mixins: [SaveHeight],

  props: {
    company: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      tasks: [],
      users: [],
      loading: true,
      creatingReminder: null,
      assigningTask: null,
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        this.getTasksPromise(),
        http.get('/api/v2/users'),
      ]).then(responses => {
        this.tasks = responses[0].data.data
        this.users = responses[1].data.data
        this.loading = false
      }).catch(error => {
        notify.error('Failed to load retention touchpoints.')
        this.loading = false
      })
    },

    loadTasks() {
      this.saveHeight()
      this.loading = true

      this.getTasksPromise().then(response => {
        this.tasks = response.data.data
        this.loading = false
      })
    },

    getTasksPromise() {
      // Fetch incomplete tasks strictly filtered by the current company
      return http.get('/api/v2/retention-touchpoint-tasks', {
        'filter[status]': 'incomplete',
        'filter[company_id]': this.company.id
      })
    },

    saveHeight() {
      if (this.$el.querySelector('.list-group')) {
        this.height = this.$el.querySelector('.list-group').clientHeight
      }
    },

    formatDate(date) {
      return moment(date).format('MMM Do, YYYY')
    },

    completeTask(task) {
      modal.confirm('Are you sure you want to mark this touchpoint as completed?', () => {
        http.post('/api/v2/retention-touchpoint-tasks/' + task.id + '/complete')
            .then(() => {
              notify.success('Retention touchpoint completed.')
              this.loadTasks()
            })
            .catch(() => {
              notify.error('Failed to complete the touchpoint.')
            })
      })
    },

    createReminder(task) {
      this.creatingReminder = task
      $('#create-retention-touchpoint-reminder-modal').modal('show')
    },

    openAssignModal(task) {
      this.assigningTask = task
      $('#assign-retention-touchpoint-modal').modal('show')
    }
  }
}
</script>